(() => {
  const isPtBr = () => (document.documentElement.lang || '').toLowerCase() === 'pt-br';

  const replaceExactText = (root, selector, replacements) => {
    root.querySelectorAll(selector).forEach((el) => {
      if (el.children.length > 0) return;
      const current = (el.textContent || '').trim();
      if (Object.prototype.hasOwnProperty.call(replacements, current)) {
        el.textContent = replacements[current];
      }
    });
  };

  const applyParity = () => {
    if (!isPtBr()) return;

    replaceExactText(document, 'h1,h2,h3,h4,h5,h6,p,span', {
      "You'll love this too": 'Você também pode precisar...'
    });

    document.querySelectorAll('.product-card__wrapper').forEach((card) => {
      replaceExactText(card, 'button,a,span', {
        'Add to cart': 'Adicionar ao carrinho',
        'Options': 'Adicionar ao carrinho'
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyParity, { once: true });
  } else {
    applyParity();
  }

  document.addEventListener('cart:updated', () => requestAnimationFrame(applyParity));
  document.addEventListener('cart:refresh', () => requestAnimationFrame(applyParity));
})();
